import React, { useId } from 'react';
import { useField } from 'formik';
import { Checkbox } from '@components/Checkbox';
import { ICheckboxFieldProps } from '@components/Form/types';
import { Field } from '../Field';

export const CheckboxField = (props: ICheckboxFieldProps) => {
  const {
    id = '',
    showLabel = false,
    label = '',
    showHint = true,
    hint = '',
    showRequired = false,
    required = true,
    checked,
    fieldControls,
    handleChange,
  } = props;

  const uniqId = useId();

  const fieldId = id || uniqId;

  const [field, meta] = useField(props);

  const onCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (handleChange) {
      handleChange(e);
    }
    field.onChange(e);
  };

  return (
    <Field
      id={fieldId}
      showLabel={showLabel}
      label={label}
      showError={meta.touched}
      error={meta.error}
      showHint={showHint}
      hint={hint}
      showRequired={showRequired}
      isRequired={required}
      fieldControls={fieldControls}
    >
      <div className="field-control">
        <Checkbox {...field} {...props} checked={checked} handleChange={onCheckboxChange} />
      </div>
    </Field>
  );
};
